import { IPageState } from '../../interfaces/onboarding/page-state/page-state.interface';

export class PageState implements IPageState {
  id: string;
  title: string;
  pageUrl: string;
  disabled = false;
  moduleId: number;

  constructor(
    obj: any = {
      id: '-1',
      title: 'DISABLED',
      pageUrl: 'DISABLED',
      disabled: true,
      moduleId: 0,
    }
  ) {
    this.id = obj.id;
    this.title = obj.title;
    this.pageUrl = obj.pageUrl;
    this.disabled = obj.disabled;
    this.moduleId = obj.moduleId;
  }
}
